import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={2}>zelfstandig</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mnl/vrl</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>quis</td>
          <td>quid</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>cuius</td>
          <td>cuius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>cui</td>
          <td>cui</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>quem</td>
          <td>quid</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">quo</td>
          <td className="bor-bot">quo</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>qui</td>
          <td>quae</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>quorum</td>
          <td>quorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>quibus</td>
          <td>quibus</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>quos</td>
          <td>quae</td>
        </tr>
        <tr>
          <th className="bor-bot col">abl. mv.</th>
          <td className="bor-bot">quibus</td>
          <td className="bor-bot">quibus</td>
        </tr>
        <tr>
          <th className="col" />
          <td className="center">
            <i>wie</i>
          </td>
          <td className="center">
            <i>wat</i>
          </td>
        </tr>
      </table>
    </div>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>bijvoeglijk</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>qui</td>
          <td>quae</td>
          <td>quod</td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>cuius</td>
          <td>cuius</td>
          <td>cuius</td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>cui</td>
          <td>cui</td>
          <td>cui</td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>

          <td>quem</td>
          <td>quam</td>
          <td>quod</td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">quo</td>
          <td className="bor-bot">qua</td>
          <td className="bor-bot">quo</td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>qui</td>
          <td>quae</td>
          <td>quae</td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>quorum</td>
          <td>quarum</td>
          <td>quorum</td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>quibus</td>
          <td>quibus</td>
          <td>quibus</td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>quos</td>
          <td>quas</td>
          <td>quae</td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td className="bor-bot">quibus</td>
          <td className="bor-bot">quibus</td>
          <td className="bor-bot">quibus</td>
        </tr>
        <tr>
          <th className="col" />
          <td colSpan={3} className="center">
            <i>welke</i>
          </td>
        </tr>
      </table>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/vr-vnw.js